export const initialState = {
  modalProductIsOpen: false,
  modalPriceUpdateIsOpen: false,
  modalImportXmlIsOpen: false,
  modalManifestedXmlsIsOpen: false,
  modalCancelPurchaseIsOpen: false,
  modalCancelPurchaseIds: [],
  loadingTabProduct: false,
  loadingTabPurchase: false,
  modalChangeCFOP: false,
};

export default {
  ...initialState,
};
